





























import Vue from 'vue';
import gql from 'graphql-tag';
import { mapKeys, upperFirst } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { ZenLink } from 'zenComponents';
import ObjectMapper, { ObjectModel } from '@/components/object_mapper/ObjectMapper.vue';
import MapperObjectsQuery from '@/graphql/MapperObjects';

export default Vue.extend({
  name: 'ObjectMapperPage',
  components: {
    ObjectMapper,
    ZenLink,
  },
  props: {
    leftType: {
      type: String,
      default: null,
    },
    rightType: {
      type: String,
      default: null,
    },
    objectIds: {
      type: String,
      default: '',
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    backUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      csrfToken: 'csrfToken',
      apiEndpoints: 'objectMapperApiEndpoints',
      rawAvailableMapTypes: 'availableMapTypes',
      modelMeta: 'modelMeta',
      modelMetaFindBy: 'modelMetaFindBy',
      routes: 'routes',
    }),
    leftColumnType() {
      return this.getModelType(this.leftType);
    },
    rightColumnType() {
      return this.rightType ? this.getModelType(this.rightType) : undefined;
    },
    leftColumnObjects() {
      return this.nodes
        ? this.nodes.map(n => ({ id: n.dbId, identifier: n.identifier.value, title: n.title.value }))
        : [];
    },
    availableMapTypes() {
      return mapKeys(this.rawAvailableMapTypes, (_, key) => upperFirst(key));
    },
    backLink() {
      const fallback = this.routes.sorListing.replace('__OBJECT_TYPE__', this.leftType);
      return this.backUrl || fallback;
    },
    completeLink() {
      const fallback = this.routes.sorListing.replace('__OBJECT_TYPE__', this.leftType);
      return this.redirectUrl || fallback;
    },
  },
  created() {
    this.setPageTitle({
      title: 'Object Mapper',
      backLink: { label: 'Back', url: this.backLink },
    });
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      showAlert: 'alerts/show',
      request: 'request',
    }),
    getModelType(type: string): ObjectModel {
      const modelMeta = this.modelMetaFindBy('modelSingular', type);

      return {
        model: modelMeta.modelSingular,
        plural: modelMeta.titlePlural,
        singular: modelMeta.titleSingular,
      };
    },
    updateRoute(newRightType: string) {
      this.$router.replace({
        name: this.$route.name,
        query: this.$route.query,
        params: {
          leftType: this.leftType,
          objectIds: this.objectIds,
          rightType: newRightType,
          redirectUrl: this.redirectUrl,
          backUrl: this.backUrl,
        },
      });
    },
  },
  apollo: {
    nodes: {
      query() {
        const ids = this.objectIds.split(',').map(Number);
        return gql(MapperObjectsQuery(this.leftColumnType.model, ids));
      },
    },
  },
});
